/* eslint-disable */

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Vuetify imports
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css'   
 
//
import '@/assets/theme.css'



// Create Vuetify instance
/*
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          background: '#212121'
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi', // ✅ tell Vuetify to use MDI
  },
});*/
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#ffffff',
          surface: '#ffffff',
          primary: '#1e88e5',
          footer: '#ededed',
          card: '#ededed',
          accent: '#f26e2e'
        },
      },
      dark: {
        dark: true,
        colors: {
          background: '#212121',
          surface: '#1e1e1e',
          primary: '#90caf9',
          footer: '#313131',
          card: '#313131',
            accent: '#f26e2e'
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
});






// Create Vue app and mount with Vuetify
createApp(App)
  .use(router)
  .use(vuetify)
  .mount("#app");
